import { findSupportedLocale } from '@architeia/utils'
import { KORA_WEB_LOCALES, type KoraWebLocale } from '@/i18n'

const STORAGE_KEY = 'kora.accountLocaleHint'

/**
 * ADR-010 D3 per-origin hint: the last account language Kora returned. It is only a placeholder
 * until the live value arrives, so a cold load does not flash the wrong language.
 */
export function readLocaleHint(): KoraWebLocale | null {
  try {
    return findSupportedLocale(KORA_WEB_LOCALES, window.localStorage.getItem(STORAGE_KEY))
  } catch {
    return null
  }
}

export function writeLocaleHint(locale: KoraWebLocale | null): void {
  try {
    if (locale === null) window.localStorage.removeItem(STORAGE_KEY)
    else window.localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // Storage can be blocked; the hint is a convenience only.
  }
}
